import { MutationTree } from 'vuex';
import { SET_SINGLE_AUTH_OF_USER, SET_GENERAL_MEMBER_INFORMATION } from './mutation-types';
import { IGeneralInfoOfMember } from '../models/interfaces/iGeneralInfoOfMember'
import { GeneralInfoOfMember } from '../models/classes/generalInfoOfMember'
import State from './state';

const mutations: MutationTree<State> = {
    [SET_SINGLE_AUTH_OF_USER](state: State, single_auth: string): void {
        state.single_auth = single_auth;
  }
};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/mutations.ts